import { useSecurityBwicHistory } from "../../effects/data-accessors/useSecurityBwicHistory";
import { useAppSelector } from "../../effects/useAppSelector";
import { SubscriptionFeature } from "../../types/billing/SubscriptionFeature";
import { isRequestSuccess, numericUtils } from "../../utils";
import { compareDatesDesc } from "../../utils/compare.utils";
import { EmptyPlaceholder, Preloader } from "../common";
import { DmWalChart } from "./DmWalChart";
import { DmWalTradingHistory } from "./DmWalTradingHistory";

interface Props {
    feature?: SubscriptionFeature
}

export function DmWalCurve({ feature }: Props) {
    const visible = useAppSelector(s => s.dmWalCurve.visible);
    const position = useAppSelector(s => s.dmWalCurve.position);
    const bwicDate = useAppSelector(s => s.dmWalCurve.bwicDate);
    const bwicsHistory = useSecurityBwicHistory(position?.securityId ?? 0);

    if (!visible || !position) return null;

    const dataItems = bwicsHistory.bwics.securities.filter(x =>
        numericUtils.isNumber(x.evalNColor) ||
        numericUtils.isNumber(x.colorWal) ||
        numericUtils.isNumber(x.colorDm) ||
        numericUtils.isNumber(x.evalPriceTalkDm) ||
        numericUtils.isNumber(x.evalPriceTalkWal) ||
        x.pxTalks?.some(p => numericUtils.isNumber(p.dm)) ||
        x.pxTalks?.some(p => numericUtils.isNumber(p.wal))
    ).sort((a, b) => compareDatesDesc(a.bidsDueUtc, b.bidsDueUtc));

    return (
        <div className="security-information dm-wal-curve">
            <Preloader inProgress={!isRequestSuccess(bwicsHistory.requestState)}>
                {
                    dataItems.length === 0
                        ? <EmptyPlaceholder text="No data available." className="text-warm-grey" />
                        : (
                            <>
                                <DmWalChart
                                    targetPositionId={position.id}
                                    history={dataItems}
                                    feature={feature}
                                    defaultDate={bwicDate}
                                />
                                <DmWalTradingHistory ticker={position.ticker} feature={feature} history={dataItems} />
                            </>
                        )
                }
            </Preloader>
        </div>
    );
}